import { axiosService } from 'service'
import { salesCajaEndpoints } from 'service/sources/sales/caja'

const cajaList = (options) => {
  return axiosService.get(salesCajaEndpoints.LIST + options)
}

const exportCaja = (body) => {
  return axiosService.post(salesCajaEndpoints.EXPORT, body)
}

const infoOneCaja = (id, empresa) => {
  return axiosService.get(salesCajaEndpoints.INFO_ONE_CAJA + id + '/' + empresa)
}

const create = (values) => {
  return axiosService.post(salesCajaEndpoints.CREATE, values)
}

const dataBefore = () => {
  return axiosService.get(salesCajaEndpoints.DATA_BEFORE)
}

const confirmCaja = (body) => {
  return axiosService.post(salesCajaEndpoints.CONFIRM_CAJA, body)
}

const updateCaja = (body) => {
  return axiosService.post(salesCajaEndpoints.UPDATE_CAJA, body)
}

const addGasto = (body) => {
  return axiosService.post(salesCajaEndpoints.ADD_GASTO, body)
}

const print = (body) => {
  return axiosService.getPDF(salesCajaEndpoints.PRINT, body)
}

const printGastos = (body) => {
  return axiosService.getPDF(salesCajaEndpoints.PRINT_GASTOS, body)
}

export const salesCaja = {
  cajaList,
  exportCaja,
  infoOneCaja,
  create,
  dataBefore,
  confirmCaja,
  updateCaja,
  addGasto,
  print,
  printGastos,
}
